import {getNewAccessToken} from './user.js';

export const setTranscriptsVideoList = (videos) => {
    return {
        type: "SET_TRANSCRIPTS_VIDEO_LIST",
        videos
    }
}

export const setTranscriptsVideoListStatus = (status) => {
    return {
        type: "SET_TRANSCRIPTS_VIDEO_LIST_STATUS",
        status
    }
}


export const setPlatformStatistics = (data) => {
    return {
        type: "SET_PLATFORM_STATISTICS",
        data
    }
}

export const setPlatformStatisticsStatus = (status) => {
    return {
        type: "SET_PLATFORM_STATISTICS_STATUS",
        status
    }
}

export const fetchPlatformStatistics = () => {
    return dispatch => {
        dispatch(setPlatformStatisticsStatus("LOADING"))
        return fetch(`https://www.api.cubits.ai/api/v1/admin/statistics/`, {
            method: "GET",
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('access'),
                'Content-Type': 'application/json'
            },
        })
        .then (response => { 
            if(response.ok){
                return response.json()
            }else {
                throw new Error(response.status);
            }
        })
        .then(data => {
            dispatch(setPlatformStatisticsStatus("LOADED"))
            dispatch(setPlatformStatistics(data))
        })
        .catch(error => {
            dispatch(setPlatformStatisticsStatus("FAILED"))
            if(parseInt(error.message) === 401){
                dispatch(getNewAccessToken(()=>fetchPlatformStatistics()))
            }
        })
    }
}

export const setClassCodesList = (codes) => {
    return {
        type: "SET_CLASS_CODES_LIST",
        codes
    }
}

export const setClassCodesListStatus = (status) => {
    return {
        type: "SET_CLASS_CODES_LIST_STATUS",
        status
    }
}

export const fetchClassCodesList = (pageNum = 1, updateTableState) => {
    return dispatch => {
        let headers = {}
        if(localStorage.getItem('access') != null){
            headers = {
                'Authorization': 'Bearer ' + localStorage.getItem('access'),
                'Content-Type': 'application/json'
            }
        }
        dispatch(setClassCodesListStatus("LOADING"))
        return fetch(`https://www.api.cubits.ai/api/v1/classcodes/?page=${pageNum}`, {
            method: "GET",
            headers: headers
        })
            .then (response => { 
                if(response.ok){
                    return response.json()
                }else {
                    throw new Error(response.status);
                }
            })
            .then(data => {
                dispatch(setClassCodesListStatus("LOADED"))
                updateTableState(pageNum, 25, data.count)
                return dispatch(setClassCodesList(data.results))
            })
            .catch(error => {
                dispatch(setClassCodesListStatus("FAILED"))
                if(parseInt(error.message) === 401){
                    dispatch(getNewAccessToken(()=>fetchClassCodesList(pageNum)))
                }
            })
    }
}

export const setClassCodeDetail = (detail) => {
    return {
        type: "SET_CLASS_CODE_DETAIL",
        detail
    }
}

export const setClassCodeDetailStatus = (status) => {
    return {
        type: "SET_CLASS_CODE_DETAIL_STATUS",
        status
    }
}

export const fetchClassCodeDetail = (code) => {
    return dispatch => {
    
        dispatch(setClassCodeDetailStatus("LOADING"))
        return fetch(`https://www.api.cubits.ai/api/v1/classcodes/${code}/roster/`, {
            method: "GET",
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('access'),
                'Content-Type': 'application/json'
            }
        })
            .then (response => { 
                if(response.ok){
                    return response.json()
                }else {
                    throw new Error(response.status);
                }
            })
            .then(data => {
                dispatch(setClassCodeDetailStatus("LOADED"))
                dispatch(setClassCodeDetail(data))
            })
            .catch(error => {
                dispatch(setClassCodeDetailStatus("FAILED"))
                if(parseInt(error.message) === 401){
                    dispatch(getNewAccessToken(()=>fetchClassCodeDetail(code)))
                }
            })
    }
}

export const fetchTranscriptsVideoList = (pageNum = 1, updateTableState) => {
    return dispatch => {
        let headers = {}
        if(localStorage.getItem('access') != null){
            headers = {
                'Authorization': 'Bearer ' + localStorage.getItem('access'),
                'Content-Type': 'application/json'
            }
        }
        dispatch(setTranscriptsVideoListStatus("LOADING"))
        return fetch(`https://www.api.cubits.ai/api/v1/videos/?page=${pageNum}`, {
            method: "GET",
            headers: headers
        })
            .then (response => { 
                if(response.ok){
                    return response.json()
                }else {
                    throw new Error(response.status);
                }
            })
            .then(data => {
                dispatch(setTranscriptsVideoListStatus("LOADED"))
                updateTableState(pageNum, 25, data.count)
                return dispatch(setTranscriptsVideoList(data.results))
            })
            .catch(error => {
                dispatch(setTranscriptsVideoListStatus("FAILED"))
                if(parseInt(error.message) === 401){
                    dispatch(getNewAccessToken(()=>fetchTranscriptsVideoList(pageNum)))
                }
            })
    }
}

export const setUploadTranscriptStatus = (status) => {
    return {
        type: "SET_UPLOAD_TRANSCRIPT_STATUS",
        status
    }
}

export const setUploadTranscriptResult = (data) => {
    return {
        type: "SET_UPLOAD_TRANSCRIPT_RESULT",
        data
    }
}

export const uploadTranscripts = (uploadData) => {
    return dispatch => {
        dispatch(setUploadTranscriptStatus("LOADING"))

        return fetch(`https://www.api.cubits.ai/api/v1/transcripts/`, {
            method: "POST",
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('access'),
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                data: uploadData
            })
        })
        .then (response => { 
            if(response.ok){
                return response.json()
            }else {
                throw new Error(response.status);
            }
        })
        .then(data => {
            dispatch(setUploadTranscriptResult(data))
            dispatch(setUploadTranscriptStatus("SUCCESS"))
        })
        .catch(error => {
            if(parseInt(error.message) === 401){
                dispatch(getNewAccessToken(()=>uploadTranscripts(uploadData)))
            }else {
                dispatch(setUploadTranscriptStatus("FAILED"))
            }
        })
    }
}

const setVideosToCurateStatus = status => {
    return {
        type: "SET_VIDEOS_TO_CURATE_STATUS",
        status
    }
}

const setVideosToCurate = videos => {
    return {
        type: "SET_VIDEOS_TO_CURATE",
        videos
    }
}
export const fetchVideosToCurate = () => {
    return dispatch => {
        let headers = {}
        if(localStorage.getItem('access') != null){
            headers = {
                'Authorization': 'Bearer ' + localStorage.getItem('access'),
                'Content-Type': 'application/json'
            }
        }
        dispatch(setVideosToCurateStatus("LOADING"))
        return fetch(`https://www.api.cubits.ai/api/v1/admin/videos-to-curate/`, {
            method: "GET",
            headers: headers
        })
            .then (response => { 
                if(response.ok){
                    return response.json()
                }else {
                    throw new Error(response.status);
                }
            })
            .then(data => {
                dispatch(setVideosToCurateStatus("LOADED"))
                return dispatch(setVideosToCurate(data.videosToCurate))
            })
            .catch(error => {
                dispatch(setVideosToCurateStatus("FAILED"))
                if(parseInt(error.message) === 401){
                    dispatch(getNewAccessToken(()=>fetchVideosToCurate()))
                }
            })
    }
}